<template>
  <div class="products-list-page">
    <loader
      ref="loader"
      class="products-list-page__loader"
      :initial-visible="false"
    />
    <h1
      id="CATEGORY_HEADLINE"
      class="products-list-page__name | headline headline--type_h1"
      v-html="headline"
    />
    <template v-if="pageType === 'cartonsearch'">
      <div class="products-list-page__teaser-top">
        <karton-suche-teaser />
      </div>
    </template>
    <template v-if="teaserTop">
      <div class="products-list-page__teaser-top">
        <template-compiler
          :template="teaserTop.data"
        />
      </div>
    </template>
    <div class="products-list-page__column">
      <filter-category
        class="products-list-page__sidebar-menu"
        v-if="navigation"
      />
      <filters class="products-list-page_filters" />
    </div>
    <div class="products-list-page__content">
      <div class="products-list-page__top-bar">
        <products-sort class="products-list-page__products-sort" />

        <pagination
          class="products-list-page__pagination products-list-page__pagination--top"
          @pagechanged="pageChangedHandler"
        />
      </div>
      <active-filters class="products-list-page__active-filters" />
      <products-list
        class="products-list-page__products-list"
        :products-list="productsList"
      />
      <div class="products-list-page__bottom-bar">
        <pagination
          class="products-list-page__pagination products-list-page__pagination--bottom"
          @pagechanged="pageChangedHandler"
        />
      </div>
    </div>
    <template v-if="teaserBottom">
      <div class="products-list-page__teaser-bottom">
        <template-compiler
          :template="teaserBottom.data"
        />
      </div>
    </template>
  </div>
</template>

<script>
import Loader from '../loader/loader.vue'
import Filters from '../filters/filters.vue'
import ProductsSort from '../productsSort/productsSort.vue'
import Pagination from '../pagination/pagination'
import ActiveFilters from '../activeFilters/activeFilters.vue'
import ProductsList from '../productsList/productsList.vue'
import FilterCategory from '../filterCategory/filterCategory.vue'
import plpStateComputedMixin from '../../utilities/vueMixins/plpStateComputedMixin/plpStateComputedMixin.js'
import TemplateCompiler from '../templateCompiler/templateCompiler.vue'
import dataLayerMixin from '../../utilities/vueMixins/dataLayerMixin/dataLayerMixin'
import {mapGetters} from 'vuex'
import {toRaw} from 'vue'
import KartonSucheTeaser from '../kartonSucheTeaser/kartonSucheTeaser.vue'

export default {
  components: {
    KartonSucheTeaser,
    Loader,
    Filters,
    ProductsSort,
    Pagination,
    ActiveFilters,
    ProductsList,
    FilterCategory,
    TemplateCompiler,
  },
  mixins: [
    plpStateComputedMixin,
    dataLayerMixin
  ],
  created() {
    this.bindHistoryEvent()
    this.saveInitialHistoryState()
  },
  computed: {
    ...mapGetters(
      'productsListPage',
      ['headline', 'resultCount', 'teaserBottom', 'teaserTop']
    )
  },
  mounted() {
    this.dataLayerTrackEvent()
  },
  methods: {
    bindHistoryEvent() {
      window.onpopstate = (event) => {
        this.$store.dispatch('productsListPage/historyPopState', event)
      }
    },
    saveInitialHistoryState() {
      window.history.replaceState(
        {
          productsList: toRaw(this.$store.state.productsListPage.elementsList),
          filters: toRaw(this.$store.state.productsListPage.filters),
          pagination: toRaw(this.$store.state.productsListPage.pagination),
          sorting: toRaw(this.$store.state.productsListPage.sorting)
        },
        document.title,
        window.location.href
      )
    },
    pageChangedHandler() {
      this.dataLayerTrackEvent()
    },
    dataLayerTrackEvent() {
      this.trackEvent({
        event: 'eec.view_item_list',
        ecommerce: {
          currencyCode: this.currencyCode,
          impressions: this.productList()
        }
      })
    },
    productList() {
      let productList = []
      const _this = this
      const searchTerm = this.searchTerm
      const pageType = this.pageType
      const pageSize = this.pageSize
      const pagination = this.$store.state.productsListPage.pagination
      const currentCategory = this.$store.state.productsListPage.currentCategory

      this.productsList
        .filter(position => position.type === 'product')
        .flatMap(position => position.data)
        .forEach(function (pos, i) {
          let index = pagination.currentPage > 1 ? i + 1 + (pageSize * (pagination.currentPage - 1)) : i + 1
          let image = pos.images[0] !== null ? pos.images[0].src : null
          productList.push({
            id: pos.articleNumber,
            itemGroupId: pos.id,
            name: pos.name,
            pricePerItemNet: _this.priceToFloat(pos.graduatedPrices[0].price),
            pricePerItemStartingAtNet: _this.priceToFloat(pos.graduatedPrices[pos.graduatedPrices.length - 1].price),
            categoryId: pos.categoryId,
            categoryName: pos.categoryName,
            list: pageType && pageType === 'search_results' ? `Suchergebnis '${searchTerm}'` : `Kategorie '${currentCategory.name}'`,
            position: index,
            primaryImageUrl: _this.getMainFormatImage(image)
          })
        })
      return productList
    },
  }
}

</script>
